module.exports = __webpack_public_path__ + "static/media/backWave3.e8339ca3.svg";